import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
import _imports_0 from '@/assets/logo.png';
import _imports_1 from '@/assets/logo-1.png';
import _imports_2 from '@/assets/logo-2.png';
import _imports_3 from '@/assets/close.png';
import _imports_4 from '@/assets/ad.png';
import _imports_5 from '@/assets/notice.png';
import _imports_6 from '@/assets/arrow_right.png';
import _imports_7 from '@/assets/down.png';
import _imports_8 from '@/assets/copy.png';
import _imports_9 from '@/assets/down_arrow_w.png';
import _imports_10 from '@/assets/down_menu.png';
var _hoisted_1 = {
  "class": "app-container"
};
var _hoisted_2 = {
  "class": "top-header"
};
var _hoisted_3 = {
  "class": "header-left"
};
var _hoisted_4 = {
  "class": "header-title"
};
var _hoisted_5 = {
  "class": "title-text"
};
var _hoisted_6 = {
  "class": "header-actions"
};
var _hoisted_7 = {
  "class": "notification-dropdown"
};
var _hoisted_8 = {
  "class": "notification-tabs"
};
var _hoisted_9 = {
  "class": "notification-list"
};
var _hoisted_10 = ["onClick"];
var _hoisted_11 = {
  "class": "notification-title"
};
var _hoisted_12 = {
  "class": "notification-time"
};
var _hoisted_13 = {
  key: 1,
  "class": "empty-notification"
};
var _hoisted_14 = {
  "class": "notification-footer"
};
var _hoisted_15 = {
  "class": "user-info"
};
var _hoisted_16 = {
  "class": "user-tag"
};
var _hoisted_17 = {
  "class": "username"
};
var _hoisted_18 = {
  "class": "user-dropdown-header"
};
var _hoisted_19 = {
  "class": "user-info-row"
};
var _hoisted_20 = {
  "class": "user-name"
};
var _hoisted_21 = {
  "class": "user-tag-blue"
};
var _hoisted_22 = {
  "class": "user-info-row"
};
var _hoisted_23 = {
  "class": "user-id"
};
var _hoisted_24 = {
  "class": "id-number"
};
var _hoisted_25 = {
  "class": "menu-item-group account-info-group"
};
var _hoisted_26 = {
  "class": "menu-item-group-out"
};
var _hoisted_27 = {
  "class": "main-container"
};
var _hoisted_28 = {
  "class": "menu-container"
};
var _hoisted_29 = {
  "class": "submenu-tooltip-group"
};
var _hoisted_30 = ["onClick", "onMouseenter"];
var _hoisted_31 = {
  "class": "submenu-tooltip-text"
};
var _hoisted_32 = ["onClick"];
var _hoisted_33 = {
  key: 1
};
var _hoisted_34 = ["onClick", "onMouseenter"];
var _hoisted_35 = {
  "class": "menu-item-content"
};
var _hoisted_36 = ["src"];
var _hoisted_37 = ["src"];
var _hoisted_38 = {
  key: 2,
  "class": "menu-title"
};
var _hoisted_39 = {
  key: 0,
  "class": "down-arrow"
};
var _hoisted_40 = ["onClick"];
var _hoisted_41 = ["onClick"];
var _hoisted_42 = {
  key: 0,
  "class": "submenu"
};
var _hoisted_43 = {
  key: 0,
  "class": "submenu-group"
};
var _hoisted_44 = {
  "class": "submenu-group-title"
};
var _hoisted_45 = ["onClick"];
var _hoisted_46 = {
  "class": "submenu-text"
};
var _hoisted_47 = ["onClick"];
var _hoisted_48 = {
  "class": "submenu-text"
};
var _hoisted_49 = {
  key: 1,
  "class": "menu-group-divider"
};
var _hoisted_50 = {
  "class": "main-content"
};
var _hoisted_51 = {
  "class": "content-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_dropdown = _resolveComponent("a-dropdown");
  var _component_a_menu_item = _resolveComponent("a-menu-item");
  var _component_a_menu = _resolveComponent("a-menu");
  var _component_a_tooltip = _resolveComponent("a-tooltip");
  var _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[14] || (_cache[14] = _createElementVNode("div", {
    "class": "logo-brand"
  }, [_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo",
    "class": "header-logo"
  }), _createElementVNode("img", {
    src: _imports_1,
    alt: "Logo",
    "class": "header-logo"
  }), _createElementVNode("img", {
    src: _imports_2,
    alt: "Logo",
    "class": "header-logo"
  })], -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.currentMenuTitle), 1)]), _ctx.showHeaderNotice ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": "header-notice-banner",
    style: _normalizeStyle({
      display: _ctx.showHeaderNotice ? 'flex' : 'none'
    })
  }, [_createElementVNode("img", {
    src: _imports_3,
    alt: "",
    "class": "notice-close-btn",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.hideHeaderNotice && _ctx.hideHeaderNotice.apply(_ctx, arguments);
    })
  }), _cache[13] || (_cache[13] = _createElementVNode("img", {
    src: _imports_4,
    alt: "",
    "class": "notice-icon"
  }, null, -1)), _createElementVNode("span", {
    "class": "notice-content",
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.navigateToMedia && _ctx.navigateToMedia.apply(_ctx, arguments);
    })
  }, "这是第一条文字广告，点击可跳转相应页面。")], 4)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
    "class": "notification-icon",
    onClick: _cache[2] || (_cache[2] = function () {
      return _ctx.toggleNotificationDropdown && _ctx.toggleNotificationDropdown.apply(_ctx, arguments);
    })
  }, _cache[15] || (_cache[15] = [_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  }, null, -1), _createElementVNode("div", {
    "class": "notification-dot"
  }, null, -1)])), _createVNode(_component_a_dropdown, {
    trigger: ['click'],
    placement: "bottomRight",
    "overlay-class-name": "custom-notification-dropdown",
    "auto-adjust-overflow": true,
    visible: _ctx.showNotificationDropdown,
    onVisibleChange: _ctx.handleNotificationVisibleChange
  }, {
    overlay: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
        "class": _normalizeClass(["tab-items", {
          active: _ctx.activeNotificationTab === 'unread'
        }]),
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return _ctx.activeNotificationTab = 'unread';
        })
      }, " 未读 ", 2), _createElementVNode("div", {
        "class": _normalizeClass(["tab-items", {
          active: _ctx.activeNotificationTab === 'all'
        }]),
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return _ctx.activeNotificationTab = 'all';
        })
      }, " 全部 ", 2)]), _createElementVNode("div", _hoisted_9, [_ctx.filteredNotifications.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(_ctx.filteredNotifications, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          "class": _normalizeClass(["notification-item", {
            unread: item.unread
          }]),
          onClick: function onClick($event) {
            return _ctx.handleNotificationClick(item);
          }
        }, [_createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(item.time), 1)], 10, _hoisted_10);
      }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[16] || (_cache[16] = [_createElementVNode("div", {
        "class": "empty-text"
      }, "暂无消息", -1)])))]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
        "class": "mark-all-read",
        onClick: _cache[5] || (_cache[5] = function () {
          return _ctx.markAllAsRead && _ctx.markAllAsRead.apply(_ctx, arguments);
        })
      }, "全部已读"), _createElementVNode("div", {
        "class": "view-all",
        onClick: _cache[6] || (_cache[6] = function () {
          return _ctx.viewAllNotifications && _ctx.viewAllNotifications.apply(_ctx, arguments);
        })
      }, _cache[17] || (_cache[17] = [_createTextVNode("查看全部 ", -1), _createElementVNode("img", {
        src: _imports_6,
        "class": "view-all-arrow",
        alt: ""
      }, null, -1)]))])])];
    }),
    _: 1
  }, 8, ["visible", "onVisibleChange"]), _createVNode(_component_a_dropdown, {
    trigger: ['click', 'hover'],
    placement: "bottomRight",
    "overlay-class-name": "custom-user-dropdown",
    "auto-adjust-overflow": true
  }, {
    overlay: _withCtx(function () {
      return [_createVNode(_component_a_menu, {
        "class": "user-dropdown-menu",
        onClick: _ctx.handleUserMenuClick
      }, {
        "default": _withCtx(function () {
          var _ctx$userInfo, _ctx$userInfo2, _ctx$userInfo5, _ctx$userInfo6;
          return [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("span", null, _toDisplayString(((_ctx$userInfo = _ctx.userInfo) === null || _ctx$userInfo === void 0 ? void 0 : _ctx$userInfo.username) || ((_ctx$userInfo2 = _ctx.userInfo) === null || _ctx$userInfo2 === void 0 ? void 0 : _ctx$userInfo2.mobile)), 1), _createElementVNode("img", {
            src: _imports_8,
            alt: "",
            "class": "copy-icon",
            onClick: _cache[7] || (_cache[7] = _withModifiers(function ($event) {
              var _ctx$userInfo3, _ctx$userInfo4;
              return _ctx.copyText(((_ctx$userInfo3 = _ctx.userInfo) === null || _ctx$userInfo3 === void 0 ? void 0 : _ctx$userInfo3.username) || ((_ctx$userInfo4 = _ctx.userInfo) === null || _ctx$userInfo4 === void 0 ? void 0 : _ctx$userInfo4.mobile) || '逆光');
            }, ["stop"]))
          })]), _createElementVNode("div", _hoisted_21, _toDisplayString(((_ctx$userInfo5 = _ctx.userInfo) === null || _ctx$userInfo5 === void 0 ? void 0 : _ctx$userInfo5.sub_account) === 1 ? '子账号' : '主账号'), 1)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_cache[19] || (_cache[19] = _createElementVNode("span", null, "用户ID", -1)), _createElementVNode("span", _hoisted_24, _toDisplayString((_ctx$userInfo6 = _ctx.userInfo) === null || _ctx$userInfo6 === void 0 ? void 0 : _ctx$userInfo6.display_id), 1), _createElementVNode("img", {
            src: _imports_8,
            alt: "",
            "class": "copy-icon",
            onClick: _cache[8] || (_cache[8] = _withModifiers(function ($event) {
              var _ctx$userInfo7;
              return _ctx.copyText(((_ctx$userInfo7 = _ctx.userInfo) === null || _ctx$userInfo7 === void 0 ? void 0 : _ctx$userInfo7.display_id) || '');
            }, ["stop"]))
          })])])]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_a_menu_item, {
            key: "account-management",
            "class": "custom-menu-item"
          }, {
            "default": _withCtx(function () {
              return _cache[20] || (_cache[20] = [_createElementVNode("span", null, "账号信息", -1)]);
            }),
            _: 1,
            __: [20]
          }), _createVNode(_component_a_menu_item, {
            key: "account-recharge",
            "class": "custom-menu-item"
          }, {
            "default": _withCtx(function () {
              return _cache[21] || (_cache[21] = [_createElementVNode("span", null, "充值记录", -1)]);
            }),
            _: 1,
            __: [21]
          })]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_a_menu_item, {
            key: "logout",
            "class": "custom-menu-item logout-item",
            onClick: _ctx.handleLogout
          }, {
            "default": _withCtx(function () {
              return _cache[22] || (_cache[22] = [_createElementVNode("span", null, "退出系统", -1)]);
            }),
            _: 1,
            __: [22]
          }, 8, ["onClick"])])];
        }),
        _: 1
      }, 8, ["onClick"])];
    }),
    "default": _withCtx(function () {
      var _ctx$userInfo8, _ctx$userInfo9, _ctx$userInfo0;
      return [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(((_ctx$userInfo8 = _ctx.userInfo) === null || _ctx$userInfo8 === void 0 ? void 0 : _ctx$userInfo8.sub_account) === 1 ? '子账号' : '主账号'), 1), _createElementVNode("span", _hoisted_17, _toDisplayString(((_ctx$userInfo9 = _ctx.userInfo) === null || _ctx$userInfo9 === void 0 ? void 0 : _ctx$userInfo9.username) || ((_ctx$userInfo0 = _ctx.userInfo) === null || _ctx$userInfo0 === void 0 ? void 0 : _ctx$userInfo0.mobile) || '用户'), 1), _cache[18] || (_cache[18] = _createElementVNode("img", {
        src: _imports_7,
        "class": "user-arrow",
        alt: ""
      }, null, -1))])];
    }),
    _: 1
  })])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", {
    "class": _normalizeClass(["sidebar", {
      'collapsed': _ctx.sidebarCollapsed
    }])
  }, [_createElementVNode("div", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, function (menu) {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: menu.key
    }, [_ctx.isMenuVisible(menu) ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createVNode(_component_a_tooltip, {
      placement: "right",
      visible: _ctx.sidebarCollapsed && _ctx.hoveredMenu === menu.key,
      "overlay-class-name": menu.children ? 'menu-tooltip-with-submenu' : 'menu-tooltip'
    }, {
      title: _withCtx(function () {
        return [menu.children ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          "class": "submenu-tooltip",
          onMouseenter: _cache[10] || (_cache[10] = function () {
            return _ctx.handleTooltipEnter && _ctx.handleTooltipEnter.apply(_ctx, arguments);
          }),
          onMouseleave: _cache[11] || (_cache[11] = function () {
            return _ctx.handleTooltipLeave && _ctx.handleTooltipLeave.apply(_ctx, arguments);
          })
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, function (submenu, subIndex) {
          return _openBlock(), _createElementBlock("div", {
            key: subIndex,
            "class": "submenu-tooltip-item"
          }, [submenu.children && submenu.children.length ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("div", _hoisted_29, _toDisplayString(submenu.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(submenu.children, function (sub3, i3) {
            return _openBlock(), _createElementBlock("div", {
              key: "".concat(submenu.key, "-").concat(i3),
              "class": "submenu-tooltip-subitem",
              onClick: function onClick($event) {
                return _ctx.handleSubmenuTooltipClick(menu, sub3);
              },
              onMouseenter: function onMouseenter($event) {
                return _ctx.hoveredSubmenu = sub3.key;
              },
              onMouseleave: _cache[9] || (_cache[9] = function ($event) {
                return _ctx.hoveredSubmenu = null;
              })
            }, [_createElementVNode("span", _hoisted_31, _toDisplayString(sub3.title), 1)], 40, _hoisted_30);
          }), 128))], 64)) : (_openBlock(), _createElementBlock("span", {
            key: 1,
            "class": "submenu-tooltip-text",
            onClick: function onClick($event) {
              return _ctx.handleSubmenuTooltipClick(menu, submenu);
            }
          }, _toDisplayString(submenu.title), 9, _hoisted_32))]);
        }), 128))], 32)) : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(menu.title), 1))];
      }),
      "default": _withCtx(function () {
        return [_createElementVNode("div", {
          "class": _normalizeClass(['menu-item', _ctx.activeMenuKey === menu.key ? 'active-menu' : 'inactive']),
          onClick: function onClick($event) {
            return _ctx.handleMenuClickCatch(menu);
          },
          onMouseenter: function onMouseenter($event) {
            return _ctx.handleMenuHover(menu);
          },
          onMouseleave: _cache[12] || (_cache[12] = function () {
            return _ctx.handleMenuLeave && _ctx.handleMenuLeave.apply(_ctx, arguments);
          })
        }, [_createElementVNode("div", _hoisted_35, [_ctx.activeMenuKey === menu.key ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: menu.selectIcon,
          alt: "",
          "class": "menu-icon"
        }, null, 8, _hoisted_36)) : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: menu.icon,
          alt: "",
          "class": "menu-icon"
        }, null, 8, _hoisted_37)), !_ctx.sidebarCollapsed ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(menu.title), 1)) : _createCommentVNode("", true)]), menu.children && !_ctx.sidebarCollapsed ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_ctx.activeMenuKey === menu.key ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _imports_9,
          "class": "menu-arrow",
          alt: "",
          onClick: _withModifiers(function ($event) {
            return _ctx.handleMenuClick(menu);
          }, ["stop"])
        }, null, 8, _hoisted_40)) : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _imports_10,
          "class": "menu-arrow",
          alt: "",
          onClick: _withModifiers(function ($event) {
            return _ctx.handleMenuClick(menu);
          }, ["stop"])
        }, null, 8, _hoisted_41))])) : _createCommentVNode("", true)], 42, _hoisted_34)];
      }),
      _: 2
    }, 1032, ["visible", "overlay-class-name"]), menu.children && menu.expanded && !_ctx.sidebarCollapsed ? (_openBlock(), _createElementBlock("div", _hoisted_42, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, function (submenu, subIndex) {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: "".concat(menu.key, "-").concat(subIndex)
      }, [submenu.children && submenu.children.length ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, _toDisplayString(submenu.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(submenu.children, function (sub3, i3) {
        return _openBlock(), _createElementBlock("div", {
          key: "".concat(menu.key, "-").concat(subIndex, "-").concat(i3),
          "class": _normalizeClass(['submenu-item', 'submenu-item-level3', _ctx.selectedKeys.includes(sub3.key) ? 'active' : '']),
          onClick: function onClick($event) {
            return _ctx.handleSubmenuClick(menu, sub3);
          }
        }, [_cache[23] || (_cache[23] = _createElementVNode("span", {
          "class": "submenu-dot"
        }, "•", -1)), _createElementVNode("span", _hoisted_46, _toDisplayString(sub3.title), 1)], 10, _hoisted_45);
      }), 128))])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        "class": _normalizeClass(['submenu-item', _ctx.selectedKeys.includes(submenu.key) ? 'active' : '']),
        onClick: function onClick($event) {
          return _ctx.handleSubmenuClick(menu, submenu);
        }
      }, [_cache[24] || (_cache[24] = _createElementVNode("span", {
        "class": "submenu-dot"
      }, "•", -1)), _createElementVNode("span", _hoisted_48, _toDisplayString(submenu.title), 1)], 10, _hoisted_47))], 64);
    }), 128))])) : _createCommentVNode("", true), menu.key === 'traffic-overview' || menu.key === 'article' || menu.key === 'draft' || menu.key === 'all-articles' || menu.key === 'knowledge-base' ? (_openBlock(), _createElementBlock("div", _hoisted_49)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 64);
  }), 128))])], 2), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createVNode(_component_router_view)])])])]);
}